import classNames from "classnames"
import React from "react"
import classes from "./RotatingButton.module.css"

export interface RotatingButtonProps {
  onClick?: () => void
  className?: string
  icon?: React.ReactNode
}

export const RotatingButton = ({
  onClick,
  icon,
  className,
}: RotatingButtonProps) => {
  const handleClick = () => {
    onClick?.()
  }
  return (
    <div
      className={classNames(classes.btn, className)}
      onClick={handleClick}
      // style={{ ["--size" as any]: size ? normalizeSize(size) : undefined }}
      // size={size}
    >
      <div className={classes.root}>{icon}</div>
    </div>
  )
}
